import { render, staticRenderFns } from "./template-work-orders.html?vue&type=template&id=043b4b00&scoped=true&"
import script from "./template-work-orders.ts?vue&type=script&lang=js&"
export * from "./template-work-orders.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043b4b00",
  null
  
)

export default component.exports